module.exports = __webpack_public_path__ + "ok.13a4f538.png";